import{View}from'./View';export class ImagePicker extends View{}